export default __webpack_public_path__ + "static/twitter-759635c9df419267077d9b991ab24f23.png";